import { Folder, FolderOpen, CaretRight, CaretDown } from "@phosphor-icons/react";

/**
 * Flatten a tree into an ordered visible list depending on `expanded` set.
 * Non-recursive to avoid Babel recursive-JSX compile issues.
 */
function flatten(node, depth, expanded, out) {
  const children = Object.values(node.children).sort((a, b) => a.name.localeCompare(b.name));
  const hasChildren = children.length > 0;
  if (node.path !== "") {
    out.push({
      path: node.path,
      name: node.name,
      depth,
      hasChildren,
      isOpen: expanded.has(node.path),
      doc_count: node.doc_count || 0,
    });
  }
  if (node.path === "" || expanded.has(node.path)) {
    for (const child of children) {
      flatten(child, depth + 1, expanded, out);
    }
  }
  return out;
}

export default function VaultTree({ root, selected, onSelect, expanded, onToggle }) {
  const items = flatten(root, -1, expanded, []);
  return (
    <>
      {items.map((it) => {
        const active = selected === it.path;
        return (
          <button
            key={it.path}
            onClick={() => onSelect(it.path)}
            className={
              "w-full text-left flex items-center gap-1 px-2 py-1.5 rounded-md text-sm transition-colors " +
              (active ? "bg-blue-700 text-white" : "hover:bg-slate-100 text-slate-700")
            }
            style={{ paddingLeft: (it.depth * 12 + 4) + "px" }}
            data-testid={"vault-folder-" + it.path}
          >
            {it.hasChildren ? (
              <span
                onClick={(e) => { e.stopPropagation(); onToggle(it.path); }}
                className={"w-4 h-4 flex items-center justify-center " + (active ? "text-blue-100" : "text-slate-400")}
              >
                {it.isOpen ? <CaretDown className="w-3 h-3" weight="bold" /> : <CaretRight className="w-3 h-3" weight="bold" />}
              </span>
            ) : (
              <span className="w-4" />
            )}
            {it.isOpen ? <FolderOpen className="w-4 h-4 shrink-0" weight="fill" /> : <Folder className="w-4 h-4 shrink-0" weight="fill" />}
            <span className="flex-1 truncate">{it.name}</span>
            {it.doc_count > 0 && (
              <span
                className={
                  "text-[10px] px-1 rounded " +
                  (active ? "bg-blue-800/40 text-blue-100" : "bg-slate-100 text-slate-600")
                }
              >
                {it.doc_count}
              </span>
            )}
          </button>
        );
      })}
    </>
  );
}
